import React from "react";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import moment from "moment";
import classNames from "classnames";
import {TooltipEx} from "./Tooltip";
import styles from "./FormButtons.module.css"
import {Trace} from "@commons/types";
import {IconCalendar, IconClock, IconInfoCircleFilled, IconUserFilled} from "@tabler/icons-react";

function _minutesFromOrTime(x?: Date, opt: { insArticolo: boolean } = {insArticolo: false}) {
    const isDefined = (value: any) => typeof value !== 'undefined';

    let trace;
    if (isDefined(x) && (trace = moment(x)).isValid()) {
        let ora = moment();
        let delta_minutes = (ora).diff(trace, 'minutes');

        if (delta_minutes <= 5 && delta_minutes > 1) {
            return delta_minutes + ' minuti fa';
        }
        if (delta_minutes <= 1) {
            return 'poco fa';
        }
        if (delta_minutes > 5) {
            let text = trace.format('HH:mm:ss');
            if (opt.insArticolo === true) {
                text = 'alle ' + text;
            }
            return text;
        }
    } else {
        return 'Data non valida.';
    }
}

function _daysFromOrDate(x?: Date) {
    const isDefined = (value: any) => typeof value !== 'undefined';

    let trace;
    if (isDefined(x) && (trace = moment(x)).isValid()) {
        let oggi = moment();
        if (oggi.isSame(trace, 'day')) {
            return 'oggi';
        } else {
            let ieri = oggi.subtract(1, 'days');
            if (ieri.isSame(trace, 'day')) {
                return 'ieri';
            } else {
                let numGiorni = oggi.diff(trace, 'days', false);
                if ((numGiorni < 6) && (oggi.week() === trace.week())) {
                    return trace.format('dddd D');
                } else {
                    return trace.format('DD/MM/YYYY');
                }
            }
        }
    } else {
        return 'Data non valida.';
    }
}

export const TraceContainer: React.FC<{ resource?: URIAndTrace, traceManager?: TraceManager }> = ({resource, traceManager}) => {
    const daysFromOrDate = (v: any) => {
        const m = v ? moment(v, 'YYYY-MM-DDTHH:mm:ss') : undefined; // es "2018-09-10T11:33:21"
        return m && m.isValid() ? _daysFromOrDate(m.toDate()) : _daysFromOrDate(undefined);
    }
    const minutesFromOrTime = (v: any) => {
        const m = v ? moment(v, 'YYYY-MM-DDTHH:mm:ss') : undefined; // es "2018-09-10T11:33:21"
        return m && m.isValid() ? _minutesFromOrTime(m.toDate()) : _minutesFromOrTime(undefined);
    }
    let insertTrace: Trace | undefined;
    let lastUpdateTrace: Trace | undefined;
    let deleteTrace: Trace | undefined;
    if (resource) {
        if (traceManager) {
            insertTrace = traceManager.getInsertInfo ? traceManager.getInsertInfo(resource) : resource.insertTrace;
            lastUpdateTrace = traceManager.getUpdateInfo ? traceManager.getUpdateInfo(resource) : resource.lastUpdateTrace;
            deleteTrace = traceManager.getDeleteInfo ? traceManager.getDeleteInfo(resource) : resource.deleteTrace;
        } else {
            insertTrace = resource.insertTrace;
            lastUpdateTrace = resource.lastUpdateTrace;
            deleteTrace = resource.deleteTrace;
        }
    }
    const cols = (insertTrace ? 1 : 0) + (lastUpdateTrace ? 1 : 0) + (deleteTrace ? 1 : 0);
    return <>
        {/*ATTENZIONE: questo costrutto generalmente non va utilizzato `grid-cols-${cols}`
                vedi:
                https://tailwindcss.com/docs/content-configuration#dynamic-class-names
                in questo caso le classi corrispondenti sono state messe nella safelist (vedi tailwind.config.js)!
                */}
        {resource && <div className={classNames('bg-green-100 grid', `grid-cols-${cols}`)}>
            <div className={`col-span-${cols} p-2 text-center`}>Informazioni di tracciabilit&agrave; record</div>
            {insertTrace && <div className="grid grid-cols-1 bg-white min-w-[144px] space-y-2">

                <div className="bg-blue-100 p-2 text-center">Info inserimento</div>
                <div className="px-3 inline-flex items-center"><IconUserFilled className="mr-1 h-5 w-5"/>
                    {insertTrace.userName}
                </div>
                <div className="px-3 inline-flex items-center"><IconCalendar className="mr-1 h-5 w-5"/>
                    {daysFromOrDate(insertTrace.timeStamp)}
                </div>
                <div className="px-3 inline-flex items-center"><IconClock className="mr-1 h-5 w-5"/>
                    {minutesFromOrTime(insertTrace.timeStamp)}
                </div>
            </div>}
            {lastUpdateTrace && <div className="grid grid-cols-1 bg-white min-w-[144px] space-y-2">
                <div className="bg-blue-200 p-2 text-center">Info modifica</div>
                <div className="px-3 inline-flex items-center"><IconUserFilled className="mr-1 h-5 w-5"/>
                    {lastUpdateTrace.userName}
                </div>
                <div className="px-3 inline-flex items-center"><IconCalendar className="mr-1 h-5 w-5"/>
                    {daysFromOrDate(lastUpdateTrace.timeStamp)}
                </div>
                <div className="px-3 inline-flex items-center"><IconClock className="mr-1 h-5 w-5"/>
                    {minutesFromOrTime(lastUpdateTrace.timeStamp)}
                </div>
            </div>}
            {deleteTrace && <div className="grid grid-cols-1 bg-white min-w-[144px] space-y-2">
                <div className="bg-red-400 p-2 text-white text-center">Info cancellazione</div>
                <div className="px-3 inline-flex items-center"><IconUserFilled className="mr-1 h-5 w-5"/>
                    {deleteTrace.userName}</div>
                <div className="px-3 inline-flex items-center"><IconCalendar className="mr-1 h-5 w-5"/>
                    {daysFromOrDate(deleteTrace.timeStamp)}
                </div>
                <div className="px-3 inline-flex items-center"><IconClock className="mr-1 h-5 w-5"/>
                    {minutesFromOrTime(deleteTrace.timeStamp)}
                </div>
            </div>}
            {cols === 0 && <div className={`p-2 text-center bg-red-400 text-white`}>Nessuna informazione disponibile!</div>}
        </div>}
    </>
}

export interface TraceManager {
    getInsertInfo?: (trace: any) => Trace | undefined;
    getUpdateInfo?: (trace: any) => Trace | undefined;
    getDeleteInfo?: (trace: any) => Trace | undefined;
}

interface FormButtonsProps {
    onCancel: () => void,
    readonly?: boolean,
    resource?: URIAndTrace,
    traceManager?: TraceManager,
    disableSave?: boolean,
    traceInfo?: boolean,
}

export const FormButtons: React.FC<FormButtonsProps> = ({onCancel, resource, traceManager, readonly = false, disableSave, traceInfo = true}) => {
    const tooltip = <TraceContainer resource={resource} traceManager={traceManager}/>;

    const btnsCancelSave = <>
        <div className="">
            <button
                type="button"
                className="bg-white btnDefault"
                onClick={() => onCancel()}>
                Chiudi
            </button>
        </div>
        {!readonly && <div className="">
            <TooltipEx tooltip={'Clicca per salvare le modifiche!'}>
                <button disabled={disableSave}
                        type="submit"
                        className="ml-3 inline-flex justify-center rounded-md border border-transparent bg-blue-600 p-1.5 sm:p-2 md:py-2 md:px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
                            disabled:opacity-50 disabled:cursor-not-allowed">
                    Salva
                </button>
            </TooltipEx>
        </div>}
    </>

    return <div className="mt-5 pt-5 w-full border-t border-gray-200">
        <div className="flex flex-row justify-start">
            {traceInfo && <div className="mr-auto self-center">
                <TooltipEx tooltip={tooltip}
                           className={classNames(styles.TraceContainer, 'bg-green-100')}> {/*N.B. E' necessario esplicitare il colore di background, altrimenti la freccia del tooltip non rispetterà il colore voluto!*/}
                    {/*<IconInfoCircleFilled className="border border-gray-200 h-8 w-8 text-blue-500"/>*/}
                    <IconInfoCircleFilled className="h-7 w-7 text-blue-500"/>
                </TooltipEx>
            </div>}
            {traceInfo && btnsCancelSave}

            {!traceInfo && <div className="inline-flex ml-auto">
                {btnsCancelSave}
            </div>}
        </div>
    </div>
}
export default FormButtons;